// extracted by mini-css-extract-plugin
export default {"container_ai":"aiDash_container_ai__lv31B","tab_btn":"aiDash_tab_btn__P1MqA","active":"aiDash_active__Iua+q"};